import styled from 'styled-components';
import Label from '../../_shared/components/Label';

export const StyledPageEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 80px 5px;
`;

export const StyledIcon = styled.div`
  transform: scale(2);
  margin-bottom: 30px;
`;

export const StyledHeader = styled(Label)`
  font-size: 18px;
  line-height: 26px;
`;

export const StyledContent = styled(Label)`
  font-size: 14px;
  line-height: 21px;
  max-width: 350px;
`;
